import { Role } from '@/Enums/Users/Role.enum';

export const mapSortToApi = (sort = []) => {
  if (!sort?.length) return null;
  return sort;
};

export const getUsersFilter = (clients: number[], advertisers: number[], roles: Role[], whitelabels: number[]) => {
  const resultFilter: Record<string, null | number[]> = {
    role_id: null,
    client_id: null,
    advertiser_id: null,
    whitelabel_id: null,
  };

  if (advertisers?.length) {
    resultFilter.advertiser_id = advertisers;
  } else if (clients?.length) {
    resultFilter.client_id = clients;
  } else if (whitelabels?.length) {
    resultFilter.whitelabel_id = whitelabels;
  }
  if (roles?.length) {
    resultFilter.role_id = roles;
  }

  return resultFilter;
};
